import axios from "axios";
import { API_ENDPOINT } from "../../../../../../lib/api-url";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const DEFAULT_AVATAR = "/avatar/avatar-default.webp";

/** Header fades/slides in once on mount */
const headerVariants = {
  hidden: { opacity: 0, y: 8 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.35, ease: "easeOut" },
  },
};

/** Parent controls sequencing: children (cards) only declare variants */
const listVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.08, // 1-by-1
      delayChildren: 0.05, // tiny delay before first
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 10, scale: 0.96 },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.35, ease: "easeOut" },
  },
};

function resolveAvatar(src) {
  if (!src) return DEFAULT_AVATAR;
  const s = String(src);
  if (
    s.startsWith("http://") ||
    s.startsWith("https://") ||
    s.startsWith("/")
  ) {
    return s;
  }
  return DEFAULT_AVATAR;
}

export function QuesionAnswersComponent({ questionId }) {
  const [users, setUsers] = useState(null); // null until loaded (no placeholders)

  useEffect(() => {
    let alive = true;
    setUsers(null); // reset on new question

    async function fetchListOfUsersAnswers() {
      try {
        const result = await axios.get(
          API_ENDPOINT.wallQuestions.getResultByQuestion(questionId)
        );
        if (!alive) return;
        const data = result?.data?.data ?? result?.data ?? [];
        const normalized = Array.isArray(data)
          ? data.map((u) => ({
              id: u?.user_id ?? `u-${Math.random()}`,
              avatar: resolveAvatar(u?.image),
              is_correct: u?.data?.is_correct === true, // true -> tick, otherwise wrong
            }))
          : [];
        setUsers(normalized);
      } catch {
        if (!alive) return;
        setUsers([]); // still render (empty)
      }
    }

    if (questionId) fetchListOfUsersAnswers();
    return () => {
      alive = false;
    };
  }, [questionId]);

  const hasData = Array.isArray(users) && users.length > 0;

  return (
    <div className="w-full items-center justify-center flex flex-col">
      {/* Header animates independently (once) */}
      {/* <motion.div
        className="w-full flex items-center justify-center flex-col gap-3"
        variants={headerVariants}
        initial="hidden"
        animate="show"
      >
        <h2 className="text-[#FFFFFF] font-bold text-[30px] flex items-center justify-center">
          نتایج
        </h2>
        <div className="relative mt-2 h-8 w-[40rem] mb-[46px]">
          <div className="absolute inset-x-20 top-0 h-[3px] w-3/4 bg-gradient-to-r from-transparent via-white/70 to-transparent blur-md" />
          <div className="absolute inset-x-20 top-0 h-px w-3/4 bg-gradient-to-r from-transparent via-white to-transparent drop-shadow-[0_0_8px_#ffffff]" />
          <div className="absolute inset-x-60 top-0 h-[6px] w-1/4 bg-gradient-to-r from-transparent via-white/80 to-transparent blur-md" />
          <div className="absolute inset-x-60 top-0 h-px w-1/4 bg-gradient-to-r from-transparent via-white to-transparent drop-shadow-[0_0_10px_#ffffff]" />
          <div className="absolute inset-x-44 top-0 h-[2px] w-2/4 bg-gradient-to-r from-transparent via-sky-100/60 to-transparent blur-[2px]" />
          <div className="pointer-events-none absolute inset-0 h-full w-full [mask-image:radial-gradient(350px_200px_at_top,transparent_20%,white)]" />
        </div>
      </motion.div> */}

      {/* Cards: parent owns stagger, children inherit. We only animate after data is ready. */}
      <motion.div
        className="w-full flex items-center justify-center  flex-wrap max-w-[1014px] gap-[45px]"
        variants={listVariants}
        initial="hidden"
        animate={hasData ? "show" : "hidden"}
      >
        {hasData &&
          users.map((u) => {
            const isCorrect = !!u.is_correct;
            return (
              <motion.div
                key={u.id}
                className="player relative w-[166px] "
                variants={itemVariants}
              >
                <img
                  src="/questions/player-box.svg"
                  className="relative z-[2]"
                  alt=""
                />
                <img
                  src={u.avatar || DEFAULT_AVATAR}
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src = DEFAULT_AVATAR;
                  }}
                  className="absolute right-[76px] top-[-32px] z-[3] w-[65px]"
                  alt=""
                />

                {isCorrect ? (
                  <div className="absolute z-[1] bottom-[12px] right-[122px] w-[100px]">
                    <img src="/questions/currect.svg" alt="" />
                    <img
                      src="/questions/tick.svg"
                      className="absolute top-[18px] left-[32px]"
                      alt=""
                    />
                  </div>
                ) : (
                  <div className="absolute z-[1] bottom-[12px] right-[122px] w-[100px]">
                    <img src="/questions/wrong.svg" alt="" />
                    <img
                      src="/questions/x.svg"
                      className="absolute top-[18px] left-[32px]"
                      alt=""
                    />
                  </div>
                )}
              </motion.div>
            );
          })}
      </motion.div>
    </div>
  );
}

export default QuesionAnswersComponent;
